
// Action Types
export const ALL_LISTING_REQUEST = 'app/EditAdsPage/ALL_LISTING_REQUEST';
export const ALL_LISTING_SUCCESS = 'app/EditAdsPage/ALL_LISTING_SUCCESS';
export const ALL_LISTING_ERROR = 'app/EditAdsPage/ALL_LISTING_ERROR';
export const PROMOTION_DRAFT_DATA_SUCCESS= 'app/EditAdsPage/PROMOTION_DRAFT_DATA_SUCCESS';

// Initial state for the notification reducer
const initialState = {
  loading: false,
  data: [],
  promotionDraftData:null,
  error: null,
};

/**
 * Notification reducer to handle different notification states.
 * @param {Object} state - The current state of the notifications.
 * @param {Object} action - The action dispatched.
 * @returns {Object} - The new state after applying the action.
 */
 const PreviewAdsPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null, // Reset error when making a new request
      };
    case ALL_LISTING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case ALL_LISTING_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PROMOTION_DRAFT_DATA_SUCCESS:
      return{
        ...state,
        promotionDraftData:action.payload
      }
    default:
      return state;
  }
};

export default PreviewAdsPageReducer;

/**
 * Action to trigger a notification request.
 * @returns {Object} - The action object.
 */
export const allListingRequest = () => ({
  type: ALL_LISTING_REQUEST,
});

/**
 * Action for a successful notification.
 * @param {Object} data - The data returned from the successful request.
 * @returns {Object} - The action object with the data payload.
 */
export const allListingSuccess = data => ({
  type: ALL_LISTING_SUCCESS,
  payload: data,
});

/**
 * Action for a failed notification.
 * @param {String} error - The error message.
 * @returns {Object} - The action object with the error payload.
 */
export const allListingError = error => ({
  type: ALL_LISTING_ERROR,
  payload: error,
});

export const promotionDraftDataSuccess = data => ({
  type: PROMOTION_DRAFT_DATA_SUCCESS,
  payload: data,
});

/**
 * Thunk action to load notifications data.
 * @returns {Function} - A function that dispatches actions based on the API response.
 */
export const loadData =() => async(dispatch, getState, sdk) => {
  dispatch(allListingRequest());
  return sdk.ownListings
    .query()
    .then(res => {
      dispatch(allListingSuccess(res?.data?.data));
    })
    .catch(err => {
      dispatch(allListingError('Error loading data!', err));
    });
};
